import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const SEO_BY_LANG = {
  it: {
    title: 'Trattoria Pizzeria Da Daniele · Cucina Italiana a Solothurn dal 2003',
    description: "Trattoria Pizzeria Da Daniele a Solothurn: autentica cucina italiana, pizza, pasta fresca, vini selezionati e terrazza panoramica nel Vigierhof. Prenota online il tuo tavolo.",
    htmlLang: 'it'
  },
  de: {
    title: 'Trattoria Pizzeria Da Daniele · Italienische Küche in Solothurn seit 2003',
    description: 'Trattoria Pizzeria Da Daniele in Solothurn: authentische italienische Küche, Pizza, hausgemachte Pasta, ausgewählte Weine und grosse Terrasse im Vigierhof. Reservieren Sie online Ihren Tisch.',
    htmlLang: 'de'
  },
  fr: {
    title: 'Trattoria Pizzeria Da Daniele · Cuisine Italienne à Soleure depuis 2003',
    description: 'Trattoria Pizzeria Da Daniele à Soleure : cuisine italienne authentique, pizza, pâtes fraîches, vins sélectionnés et grande terrasse dans le Vigierhof. Réservez votre table en ligne.',
    htmlLang: 'fr'
  },
  en: {
    title: 'Trattoria Pizzeria Da Daniele · Italian Restaurant in Solothurn since 2003',
    description: 'Trattoria Pizzeria Da Daniele in Solothurn: authentic Italian cuisine, pizza, fresh pasta, selected wines and a large terrace in the Vigierhof. Book your table online.',
    htmlLang: 'en'
  }
};

const setMetaContent = (selector, content) => {
  const el = document.querySelector(selector);
  if (el) {
    el.setAttribute('content', content);
  }
};

/**
 * Keeps document.title, meta description, html[lang] and OG tags in sync
 * with the currently active language. Runs on every language change.
 */
export const useSEO = () => {
  const { language } = useLanguage();

  useEffect(() => {
    const seo = SEO_BY_LANG[language] || SEO_BY_LANG.it;

    document.title = seo.title;
    document.documentElement.setAttribute('lang', seo.htmlLang);

    setMetaContent('meta[name="description"]', seo.description);
    setMetaContent('meta[property="og:title"]', seo.title);
    setMetaContent('meta[property="og:description"]', seo.description);
    setMetaContent('meta[property="og:locale"]',
      language === 'it' ? 'it_IT' :
      language === 'de' ? 'de_CH' :
      language === 'fr' ? 'fr_CH' : 'en_US'
    );
    setMetaContent('meta[name="twitter:title"]', seo.title);
    setMetaContent('meta[name="twitter:description"]', seo.description);
  }, [language]);
};
